import { Action as HistoryAction, Location as HistoryLocation } from 'history';

import { PAGE_LIST } from '@/constants/pages';

export enum CustomHistoryActionEnum {
  ResetFilters = 'reset-filters',
  SetFilters = 'set-filters',
}

export enum QueryParamsEnum {
  ScrollTo = 'scroll-to',
}

export type LocationStateType = {
  currentPage?: (typeof PAGE_LIST)[number];
  lastPage?: (typeof PAGE_LIST)[number];
  action?: CustomHistoryActionEnum;
  [k: string]: unknown;
};

export type HistoryStateType = {
  action: HistoryAction;
  location: Omit<HistoryLocation, 'state'> & {
    state: LocationStateType;
  };
};
